<template>
  <div class="people-section">
    <!-- 标题：红色竖线 + 标题文字 -->
    <div class="people-section__header">
      <span class="people-section__indicator"></span>
      <span class="people-section__title">{{ title }}</span>
    </div>

    <!-- 专访卡片网格（2列 × 2行） -->
    <div class="people-section__grid">
      <div
        v-for="(item, idx) in displayItems"
        :key="idx"
        class="people-card"
        @click="goDetail(item)"
      >
        <span class="people-card__title">{{ item.title }}</span>
        <div
          class="people-card__image"
          :style="{ backgroundImage: `url(${item.coverImage})` }"
        >
          <div
            class="people-card__badge"
            :style="{ backgroundImage: `url(${badgeBg})` }"
          >
            <span class="people-card__badge-text">专访</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部分割线 -->
    <div class="people-section__divider"></div>
  </div>
</template>

<script>
export default {
  name: 'PeopleSection',
  props: {
    title: { type: String, default: '人物' },
    items: {
      type: Array,
      required: true
    },
    badgeBg: { type: String, required: true }
  },
  computed: {
    displayItems() {
      return this.items.slice(0, 4);
    }
  },
  methods: {
    goDetail(item) {
      if (!item || !item.newsCode) return;
      this.$router.push(`/detail?newsCode=${item.newsCode}`);
    }
  }
};
</script>

<style scoped>
.people-section {
  width: var(--content-width);
}

/* ── 标题区域 ── */
.people-section__header {
  display: flex;
  align-items: center;
  height: 44px;
}

.people-section__indicator {
  display: block;
  width: 6px;
  height: 30px;
  background-color: var(--color-primary);
  border-radius: var(--radius-full);
  flex-shrink: 0;
}

.people-section__title {
  color: var(--color-black);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  font-weight: var(--weight-bold);
  white-space: nowrap;
  line-height: 30px;
  margin-left: var(--space-2);
}

/* ── 卡片网格 ── */
.people-section__grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: var(--content-width);
  margin-top: 23px;
}

.people-card {
  display: flex;
  flex-direction: column;
  width: 366px;
  height: 318px;
  text-decoration: none;
  margin-bottom: 23px;
  cursor: pointer;
}

.people-card__title {
  display: block;
  width: 365px;
  height: 68px;
  color: var(--color-black);
  font-size: var(--font-xl);
  font-family: var(--font-primary);
  text-align: left;
  line-height: 36px;
  margin-bottom: var(--space-4);
}

.people-card__image {
  position: relative;
  width: 366px;
  height: 210px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: var(--radius-sm);
}

.people-card__badge {
  position: absolute;
  top: 0;
  left: var(--space-5);
  width: 57px;
  height: 44px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.people-card__badge-text {
  color: var(--color-white);
  font-size: var(--font-sm);
  font-family: var(--font-primary);
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}
.people-section__divider {
  width: var(--content-width);
  height: 1px;
  background-color: #EBEBEB;
}
</style>
